import pino from "pino";
import { runningInBrowser } from "~/const/browser";

const labels = pino().levels.labels;
const isEnabledLogging = (process.env.BUILD_MODE === "stg" || process.env.BUILD_MODE === "prd") && !runningInBrowser;

export const logger = pino({
  level: "info",
  enabled: isEnabledLogging,
  browser: {
    write(obj) {
      try {
        console.log(JSON.stringify(obj));
      } catch (e: unknown) {
        console.log(JSON.stringify(e, ["name", "message", "stack"]));
      }
    },
  },
  mixin: (_, level) => {
    return { severity: labels[level].toUpperCase() };
  },
});
